// @ts-nocheck
// ComingSoon — a premium, animated placeholder card used while a feature is
// being crafted. Web-rendered (divs + theme.css animations). Positive, hopeful
// copy; floating gradient icon, halo rings, glow, sparkles, a sheen sweep, a
// gradient title and a "building" shimmer bar.
import React from 'react';
import { ScreenShell } from './WebShell';

const ICONS: Record<string, string> = {
  rocket: '<path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>',
  mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>',
  template: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/>',
  bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>',
  bolt: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>',
};

export function ComingSoon({
  crumbs,
  title = 'Coming soon',
  subtitle = "Something delightful is on the way. We're crafting this experience to be worth the wait.",
  eyebrow = 'In the works',
  chip = '✨ In active development — worth the wait',
  icon = 'rocket',
}: any) {
  const path = ICONS[icon] || ICONS.rocket;
  return (
    <ScreenShell crumbs={crumbs}>
      <div className="sk-coming">
        <div className="sk-coming-card">
          <div className="sk-coming-glow" />
          <div className="sk-coming-icon">
            <span className="sk-coming-spin" />
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" dangerouslySetInnerHTML={{ __html: path }} />
          </div>
          <div className="sk-coming-eyebrow">{eyebrow}</div>
          <div className="sk-coming-title">{title}</div>
          <div className="sk-coming-sub">{subtitle}</div>
          <div className="sk-coming-bar"><span className="sk-coming-bar-fill" /></div>
          <div className="sk-coming-chip">{chip}</div>
        </div>
      </div>
    </ScreenShell>
  );
}

export default ComingSoon;
